import { render, staticRenderFns } from "./mProductRow.vue?vue&type=template&id=4baa6f6c&scoped=true"
import script from "./mProductRow.vue?vue&type=script&lang=ts"
export * from "./mProductRow.vue?vue&type=script&lang=ts"
import style0 from "./mProductRow.vue?vue&type=style&index=0&id=4baa6f6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa6f6c",
  null
  
)

export default component.exports